import React, {Component} from 'react';
import { Upload, Icon, Empty, Button, Progress } from 'antd';
import { VIDEO_TYPE, AUDIO_TYPE, ATTCHMENT_TYPE} from '../../constants';
import uploadIcon from './upload.png';
import uploadingIcon from './uploading.png';
import './uploadWall.css';
import PDF from './images/PDF.png'
import RAR from './images/RAR.png'
import TXT from './images/TXT.png'
import WORD from './images/Word.png'
import XLXS from './images/XLXS.png'
import ZIP from './images/zip.png'
import PPT from './images/ppt.png'
import AUDIO from './images/AUDIO.png'
import FILE from './images/file.png'


class UploadWallPackage extends Component {

    getFileUrl = (file) => {
        if(file.ext){
            if(VIDEO_TYPE.indexOf(file.ext.toUpperCase()) > -1){ //视频类型
                file.url = file.url.replace(/(\/storage\/[a-zA-Z0-9]{32}).*/, "$1") + "/thumbnails/1?version="+Math.random();
            } else if(ATTCHMENT_TYPE.indexOf(file.ext.toUpperCase()) > -1){  //附件类型
                if(file.ext === 'pdf'){
                    file.url = PDF
                } else if(file.ext === 'rar'){
                    file.url = RAR
                } else if(file.ext === 'txt'){
                    file.url = TXT
                } else if(file.ext === 'docx' || file.ext === 'doc'){
                    file.url = WORD
                } else if(file.ext === 'xlsx' || file.ext === 'xls'){
                    file.url = XLXS
                } else if(file.ext === 'zip'){
                    file.url = FILE
                } else if(file.ext === 'ppt' || file.ext === 'pptx'){
                    file.url = PPT
                } else {
                    file.url = <img  src={"images/file.png"} width={70} height={90} />;
                }
            } else if(AUDIO_TYPE.indexOf(file.ext.toUpperCase()) > -1){ //音频 类型
                file.url = AUDIO
            }
        }
        return file
    }

    getFoldeUrl = (file) => {
        file.url = FILE
        return file
    }

    

    render() {
        const size = 120;
        return (
            <div style={{width:"100%", paddingTop:10, backgroundColor:"#fff", overflow: 'hidden', ...this.props.style}}>
                {this.props.fileList && this.props.fileList.length > 0 && this.props.fileList.map((item, index)=>{
                    if(this.props.listType === "list"){
                        return <FileListItem
                            key={index}
                            onPreview={this.props.onPreview}
                            onRemove={this.props.onRemove}
                            onPlay={this.props.onPlay}
                            onDownload={this.props.onDownload}
                            icons={this.props.icons}
                            size={size} file={item}/>
                    }
                    return <FileBlock 
                          size = {size} 
                          //file = {item}
                          key={index}
                          onPreview={this.props.onPreview}
                          onRemove={this.props.onRemove}
                        onPlay={this.props.onPlay}
                        // onDownload={this.props.onDownload}
                          icons={this.props.icons}
                          onDoubleClick={item.type === 'folder' ? this.props.onDoubleClick : () => {}}
                          file={this.getFileUrl(item)}
                        // file={item.type === 'folder' ? this.getFoldeUrl(item) : this.getFileUrl(item)} key={item.resourceId} 
                    />   
                })}
            </div>
        );
    }
}
UploadWallPackage.defaultProps={
    uploadBtnName: "上传文件",
    showUploadBtn:true,//默认显示
    listType:"card",
    style:{}
};

class FileListItem extends Component{

    state={shade:false};

    render() {
        return <table className={"upload-wall-file-list"} cellSpacing={0} cellPadding={0} border={0} width={"100%"} onMouseOver={(e)=>{this.setState({shade:true})}} onMouseOut={(e)=>this.setState({shade: false})} >
            <tbody>
                <tr>
                    <td rowSpan={2} width={42} valign={"middle"}><Icon type="api" style={{fontSize:"25px"}} /></td>
                    <td>{!this.props.file.url?(this.props.file.ingStatus?this.props.file.ingStatus:"加载中，请稍后..."):this.props.file.name}</td>
                    <td rowSpan={2} width={50} valign={"middle"} align={"center"}>
                        <div style={{display:this.state.shade?"block":"none"}}>
                            {this.props.icons.indexOf("download")!==-1?<Icon type={"download"} onClick={()=>{
                                this.props.onDownload(this.props.file);
                            }} style={{fontSize:20}}/>:""}

                            {this.props.icons.indexOf("delete")!==-1?<Icon type={"close-circle"} onClick={()=>{
                                this.props.onRemove(this.props.file);
                            }} style={{marginLeft:"10px",fontSize:20}}/>:""}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td><Progress percent={this.props.file.url?100:parseInt(this.props.file.percent)} /></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    }

}
FileListItem.defaultProps={
    file:{
        ingStatus:"加载中"//有的时候不是加载中，比如视频上传完了之后会有多种形态，比如合并中，转码中等，这个时候就需要外面把状态传进来
    },
    icons:["download", "delete"],
    onPreview:()=>{},
    onRemove:()=>{},
    onDownload:(file)=>{
        if(file.url.indexOf("?") === -1){
            window.location.href = file.url + "?download=1";
        }else{
            window.location.href = file.url + "&download=1";
        }
    },
    onPlay:()=>{}
};

class FileBlock extends Component{
    constructor(props){
        super(props);
        this.state = {
            shade:false
        }
    }

    // getFileUrl = (file) => {
        // if(file.ext){
        //     if(VIDEO_TYPE.indexOf(file.ext.toUpperCase()) > -1){ //视频类型
        //         file.url =  file.url + "/thumbnails/1";
        //     } else if(ATTCHMENT_TYPE.indexOf(file.ext.toUpperCase()) > -1){  //附件类型
        //         if(file.ext === 'pdf'){
        //             file.url = PDF
        //         } else if(file.ext === 'rar'){
        //             file.url = RAR
        //         } else if(file.ext === 'txt'){
        //             file.url = TXT
        //         } else if(file.ext === 'docx' || file.ext === 'doc'){
        //             file.url = WORD
        //         } else if(file.ext === 'xlsx' || file.ext === 'xls'){
        //             file.url = XLXS
        //         } else if(file.ext === 'zip'){
        //             file.url = ZIP
        //         } else if(file.ext === 'ppt' || file.ext === 'pptx'){
        //             file.url = PPT
        //         } else {
        //             file.url = <img  src={"images/file.png"} width={70} height={90} />;
        //         }
        //     } else if(AUDIO_TYPE.indexOf(file.ext.toUpperCase()) > -1){ //音频 类型
        //         file.url = AUDIO
        //     }
        // }
        // return file
    // }


    renderDefaultResource = () => {
        if(this.props.file.isChunk){
            return(
                <div style={{ textAlign: "center" }}>
                    <Icon type="sync" style={{ fontSize: "30px", margin: "0 auto 8px auto", display: "block", color: "#a4adc8" }} spin />
                    <span style={{ color: "#a4adc8" }}>上传中{this.props.file.percent ? this.props.file.percent + "%" : ""}</span>
                </div>
            )
        } else{
            return (
                <div>
                    <img src={uploadingIcon} width="30" style={{ margin: "0 auto 8px auto", display: "block" }} />
                    <span style={{ color: "#a4adc8" }}>加载中</span>
                </div>
            )
        }
    }

    renderResource = () => {  //视频 附件 文件夹
        const padding = 20;
        const descHeight = 20;
        let file = this.props.file
  
            if(this.props.file.type === 'picture' || this.props.file.type === 'video' || this.props.file.type === 'attachment'){
               // let file = this.getFileUrl(this.props.file);
               // console.log(file)
                return(
                    <div style={{ width: this.props.size - padding + "px", height: this.props.size - padding + "px", textAlign: "center" }}>
                    <div style={{ width: this.props.size - padding, height: this.props.size - padding - descHeight, display: 'flex', justifyContent: 'center', alignItems: 'center' }}><img src={file.url} style={{ width: 'auto', height: 'auto', maxWidth: this.props.size - padding, maxHeight: this.props.size - padding - descHeight }} alt="" /></div>
                    <div style={{ textAlign: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{file.name}</div>
                </div>
                )
            } else {
                return(
                    <div style={{ width: this.props.size - padding + "px", height: this.props.size - padding + "px", textAlign: "center" }}>
                    <div style={{ width: this.props.size - padding, height: this.props.size - padding - descHeight, display: 'flex', justifyContent: 'center', alignItems: 'center' }}><img src={FILE} style={{ width: 'auto', height: 'auto', maxWidth: this.props.size - padding, maxHeight: this.props.size - padding - descHeight }} alt="" /></div>
                    <div style={{ textAlign: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{this.props.file.name}</div>
                </div>
                )
    
            }
    }

    render() {
        const padding = 20;
        const descHeight = 20;
        // const uploadingEl = <div style={{textAlign:"center"}}>
        //     <Icon type="sync" style={{fontSize:"30px",margin: "0 auto 8px auto",display: "block",color:"#a4adc8"}} spin />
        //     <span style={{color:"#a4adc8"}}>上传中{this.props.file.percent?this.props.file.percent+"%":""}</span>
        // </div>;
        // const loadingEl = <div>
        //     <img src={uploadingIcon} width="30" style={{margin: "0 auto 8px auto",display: "block"}} />
        //     <span style={{color:"#a4adc8"}}>{this.props.file.ingStatus?this.props.file.ingStatus:"加载中"}</span>
        // </div>;
        let isShowLeft = false;
        // console.log(this.props.file)
        return (
            <div
                onMouseOver={(e)=>{this.setState({shade:true})}} onMouseOut={(e)=>this.setState({shade: false})}
                onDoubleClick ={this.props.file.type === 'folder' ? () => this.props.onDoubleClick(this.props.file.id) : null}
                style={{width: this.props.size+"px",height: this.props.size+"px", backgroundColor: "#f4f6fc",
                cursor: "pointer",
                marginRight:"15px",
                marginBottom:"15px",
                float:"left",
                /*flex 布局*/
                display: "flex",
                /*实现垂直居中*/
                alignItems: "center",
                /*实现水平居中*/
                justifyContent: "center",
                position:"relative",
                ...this.props.style,
                
            }}  className="upload-block-item" >
                {/* {(this.props.file.status !== "done")?uploadingEl
                    :!this.props.file.url ?loadingEl:
                    <div style={{width: this.props.size - padding + "px",height: this.props.size - padding + "px",textAlign:"center"}}>
                        {this.props.file.icon?this.props.file.icon: <div style={{ width: this.props.size - padding, height:this.props.size - padding - descHeight, display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img src={this.props.file.url}   style={{ width:'auto', height:'auto', maxWidth:this.props.size - padding, maxHeight: this.props.size - padding - descHeight}} alt=""/></div>}
                        <div style={{textAlign:"center", whiteSpace: "nowrap",overflow: "hidden", textOverflow: "ellipsis"}}>{this.props.file.name}</div>
                    </div>} */}
                    {/* {} */}
                {
                     this.props.file.status !== 'done' ? this.renderDefaultResource() :  this.renderResource()
                }

                {/*{"这下面和上面判断是一样的，下面是遮罩的显示"}*/}
                {this.props.file.type === 'folder' ? <div onClick={()=>{ this.props.onRemove(this.props.file); }} style={{width:"20px", height:"20px",textAlign:"center",position:"absolute",top:"-8px",right:"-8px",display:this.state.shade?"flex":"none", justifyContent:'center', alignItems: 'center', borderRadius: '50%',background: '#0050B3'}}><Icon type="close" style={{ color: '#fff'}}/></div> : (this.props.file.status !== "done")?""
                    :!this.props.file.url ?"":
                <div style={{width:"100%", height:"100%",textAlign:"center", backgroundColor:'rgba(0,0,0,0.65)',position:"absolute",top:"0px",left:"0px",display:this.state.shade?"block":"none"}}>
                    {this.props.icons.indexOf("eye")!==-1?(()=>{
                        let res = <Icon type={"eye"} onClick={()=>{
                            this.props.onPreview(this.props.file);
                        }} style={{marginTop:"44px",color:"#fff",fontSize:20}}/>
                        isShowLeft = true;
                        return res;
                    })():""}

                    {this.props.icons.indexOf("play")!==-1?(()=>{
                        let res = <Icon type={"play-circle"} onClick={()=>{
                            this.props.onPlay(this.props.file);
                        }} style={{marginTop:"44px",marginLeft:isShowLeft?"10px":"0px",color:"#fff",fontSize:20}}/>
                        isShowLeft = true;
                        return res;
                    })():""}

                    {this.props.icons.indexOf("download")!==-1?(()=>{
                        let res = <Icon type={"download"} onClick={()=>{
                            this.props.onDownload(this.props.file);
                        }} style={{marginTop:"44px",marginLeft:isShowLeft?"10px":"0px",color:"#fff",fontSize:20}}/>
                        isShowLeft = true;
                        return res;
                    })():""}

                    {this.props.icons.indexOf("delete")!==-1?<Icon type={"delete"} onClick={()=>{
                        this.props.onRemove(this.props.file);
                    }} style={{marginTop:"44px",marginLeft:isShowLeft?"10px":"0px",color:"#fff",fontSize:20}}/>:""}

                </div>}
            </div>);
    }
}
FileBlock.defaultProps={
    size: 100,
    style:{},
    file:{
        ingStatus:"加载中"//有的时候不是加载中，比如视频上传完了之后会有多种形态，比如合并中，转码中等，这个时候就需要外面把状态传进来
    },
    icons:["eye", "play", "download", "delete"],
    onPreview:()=>{},
    onRemove:()=>{},
    onDownload:(file)=>{

        if(file.type === 'attachment'){
           // file.url =  file.path
        }
        if(file.path.indexOf("?") === -1){
            window.location.href = file.path + "?download=1";
        }else{
            window.location.href = file.path + "&download=1";
        }
    },
    onPlay:()=>{}
};
export default UploadWallPackage;